var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex items-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$tk(_vm.k))}}),(_vm.tooltip)?_c('PTooltip',{staticClass:"ml-1 text-xs",attrs:{"content":_vm.tooltip}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }